import { LOG_LEVELS } from "../constants/LogLevels"
import { extractList, sendToLogServer } from "../core/service/BusinessLogicService"
import { digitalJourneyApigateway } from "../intances/apigateway"

export function getDepartmentsByCodeAndJourneyCode(tunnelData, { countryCodeFromLanguage, countryCode, languageTag }) {
  const params = new URLSearchParams()
  const queryParameters = [
    { label: "journeyCountryCode", value: countryCodeFromLanguage },
    { label: "countryCode", value: countryCode },
    { label: "languageTag", value: languageTag }
  ]

  queryParameters.forEach((param) => {
    if (param.value == null) return

    params.append(param.label, param.value)
  })

  const API_URL_GET_DEPARTMENTS = `middle-business-service/api/v2/repository/departments/codes?`

  return digitalJourneyApigateway(tunnelData)
    .get(API_URL_GET_DEPARTMENTS + params)
    .then((response) => {
      return extractList(response.data)
    })
    .catch((error) => {
      sendToLogServer(
        LOG_LEVELS.ERROR,
        `An error occured when retrieving departments by code, error message => ${error.message}`
      )
      throw error
    })
}
